import React, { useRef } from "react";
import _ from "lodash";
import Skeleton from "@material-ui/lab/Skeleton";

import { chatDate } from "../../../utils/helper";
import Avatar from "../../../components/common/AvtarImage";
import noMessage from "../../../assets/svg/no-message-vector.svg";

interface IMessagesList {
  messagesList: Array<any>;
  activeRoomDetails: object;
  loadMoreMessages: () => void;
  loading?: boolean;
}

const MessagesList = ({
  messagesList,
  activeRoomDetails,
  loadMoreMessages,
  loading = false,
}: IMessagesList) => {
  const scrollDiv = useRef<HTMLDivElement>(null);
  const _handleScrollToTop = (e) => {
    const target = e.currentTarget as HTMLElement;

    const scrollOffset = 200;
    const reachedTop = target.scrollTop - scrollOffset;
    if (reachedTop < 0) {
      if (typeof loadMoreMessages === "function") {
        loadMoreMessages();
      }
    }
  };

  return (
    <div className="chat-message-list">
      <div
        id="chat-message-list"
        ref={scrollDiv}
        className="slim-scrollbar inner-chat-message-list"
        onScroll={(e) => _handleScrollToTop(e)}
      >
        {loading ? (
          <div className="messages-list-shimmer" style={{ padding: "12px 16px" }}>
            {[1, 2, 3, 4, 5, 6].map((row) => (
              <Skeleton
                key={row}
                variant="rect"
                height={44}
                style={{
                  marginBottom: 14,
                  borderRadius: 8,
                  maxWidth: row % 2 === 0 ? "78%" : "62%",
                  marginLeft: row % 2 === 0 ? 0 : "auto",
                }}
              />
            ))}
          </div>
        ) : messagesList.length > 0 ? (
          <>
            {(messagesList || []).map((row, key) => {
              if ((row.messageFrom || "") === "me") {
                return (
                  <div className="message-row you-message" key={key}>
                    <div className="message-content">
                      <div
                        className="message-text"
                        dangerouslySetInnerHTML={{
                          __html: row.message,
                        }}
                      />
                      <div className="message-time">
                        {chatDate(row.timeStamp, true)}
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className="message-row other-message" key={key}>
                    <div className="message-content">
                      <Avatar
                        src={_.get(activeRoomDetails, "receiverProfile", "")}
                        size="xsm"
                        type={
                          _.get(activeRoomDetails, "isCompany")
                            ? "company"
                            : "candidate"
                        }
                      />
                      <div className="msg-content-wrap">
                        <div
                          className="message-text"
                          dangerouslySetInnerHTML={{
                            __html: row.message,
                          }}
                        />
                        <div className="message-time">
                          {chatDate(row.timeStamp, true)}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          </>
        ) : (
          <div className="no-message-wrapper">
            <img src={noMessage} alt="" />
            <p>
              {`Start a conversation with ${_.get(
                activeRoomDetails,
                "receiverName",
                ""
              )}`}{" "}
              <br />
              by sending a message.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessagesList;
